import React from 'react';

import {Avatar, Badge, useTheme} from '@mui/material';

import {imageUrl} from 'lib/media';
import {memberInfo} from 'module/client/team/member/useInfo';

const styles = {
    playerAvatar: theme => ({
        width: 60,
        height: 60,
        cursor: 'grab',

        border: `2px solid ${theme.palette.lineup.avatarBorder}`,
        '&:hover': {
            transform: 'scale(1.03)',
        },
        '&:active': {
            transform: 'scale(1.07)',
            cursor: 'grabbing',
        },
        textTransform: 'uppercase',
    }),
    playerDisabled: theme => ({
        opacity: theme.palette.lineup.playerDisabled,
        filter: 'grayscale(0.6) blur(0.5px)',
        overflow: 'hidden',

        '&:hover': {
            transform: 'scale(1)',
            cursor: 'default',
        },
        '&:active': {
            transform: 'scale(1)',
            cursor: 'default',
        },
    }),
};

const PlayerBadge = ({player, colors, disabled}) => {
    const theme = useTheme();

    if (!player?.number) {
        return null;
    }

    const playerImage = player?.user?.image || null;
    const {initials} = memberInfo(player);
    let avatarColors = {color: colors.value2, backgroundColor: colors.value1};
    return (
        <Badge>
            <Avatar
                sx={{
                    ...styles.playerAvatar(theme),
                    ...(!playerImage && avatarColors),
                    ...(disabled && styles.playerDisabled(theme))
                }}
                src={playerImage ? imageUrl(playerImage, {w: 112, h: 112}) : undefined}
            >
                {initials}
            </Avatar>
        </Badge>
    );
};

export default PlayerBadge;